import { render, staticRenderFns } from "./ResourceRegistration.vue?vue&type=template&id=6c563e44&scoped=true"
import script from "./ResourceRegistration.vue?vue&type=script&lang=ts"
export * from "./ResourceRegistration.vue?vue&type=script&lang=ts"
import style0 from "./ResourceRegistration.vue?vue&type=style&index=0&id=6c563e44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c563e44",
  null
  
)

/* custom blocks */
import block0 from "./resource.fr.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fcodebuild%2Foutput%2Fsrc3399026096%2Fsrc%2Fgit-codecommit.eu-west-3.amazonaws.com%2Fv1%2Frepos%2Farqana-front-myarqana%2Fsrc%2Fviews%2Fregistration%2Fresources%2FResourceRegistration.vue&external"
if (typeof block0 === 'function') block0(component)
import block1 from "./resource.en.json?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Fcodebuild%2Foutput%2Fsrc3399026096%2Fsrc%2Fgit-codecommit.eu-west-3.amazonaws.com%2Fv1%2Frepos%2Farqana-front-myarqana%2Fsrc%2Fviews%2Fregistration%2Fresources%2FResourceRegistration.vue&external"
if (typeof block1 === 'function') block1(component)
import block2 from "@/utils/horseType.fr.json?vue&type=custom&index=2&blockType=i18n&issuerPath=%2Fcodebuild%2Foutput%2Fsrc3399026096%2Fsrc%2Fgit-codecommit.eu-west-3.amazonaws.com%2Fv1%2Frepos%2Farqana-front-myarqana%2Fsrc%2Fviews%2Fregistration%2Fresources%2FResourceRegistration.vue&external"
if (typeof block2 === 'function') block2(component)
import block3 from "@/utils/horseType.en.json?vue&type=custom&index=3&blockType=i18n&issuerPath=%2Fcodebuild%2Foutput%2Fsrc3399026096%2Fsrc%2Fgit-codecommit.eu-west-3.amazonaws.com%2Fv1%2Frepos%2Farqana-front-myarqana%2Fsrc%2Fviews%2Fregistration%2Fresources%2FResourceRegistration.vue&external"
if (typeof block3 === 'function') block3(component)

export default component.exports